import request from '@/utils/request'
// ---------------------------------------------------------------------
// 标签
// ----------------------------------------------------------------------
// 新增标签 post gallery/createTag，参数：
// title // 标题
// icon // icon图标
// level // 级别，整数，默认1
// parentTagId // 上级ID，level==1时选填，level > 1时必填
// order // 排序
export function createTag(data) {
    return request({
        url: '/gallery/createTag',
        method: 'post',
        data,
    })
  }
// 修改标签 post gallery/updateTag，参数：
// tagId // ID
// title // 标题
// icon // icon图标
// level // 级别，整数，默认1
// parentTagId // 上级ID，level==1时选填，level > 1时必填
// order // 排序
export function updateTag(data) {
    return request({
        url: '/gallery/updateTag',
        method: 'post',
        data,
    })
  }
// 删除标签 post gallery/removeTag，参数：
// tagId // ID
export function removeTag(data) {
    return request({
        url: '/gallery/removeTag',
        method: 'post',
        data,
    })
  }
// 获取单个标签 get gallery/findTag, 参数：
// tagId // ID
export function findTag(params) {
    return request({
        url: '/gallery/findTag',
        method: 'get',
        params,
    })
  }
// 获取标签列表 get gallery/findTagList, 参数：
// page
// size
// keyword // 关键词，搜索标题
export function findTagList(params) {
    return request({
        url: '/gallery/findTagList',
        method: 'get',
        params,
    })
  }
// 获取所有标签 get gallery/findTagAll, 参数：
// keyword // 关键词，搜索标题
export function findTagAll(params) {
    return request({
        url: '/gallery/findTagAll',
        method: 'get',
        params,
    })
  }
// ---------------------------------------------------------------------
// 物件
// ----------------------------------------------------------------------

// 新增物件 post gallery/createItem，参数：
// title // 标题
// avatar // 封面图片
// tagIdList // 标签列表
// text // 备注
// order // 排序
export function createItem(data) {
    return request({
        url: '/gallery/createItem',
        method: 'post',
        data,
    })
  }
// 修改物件 post gallery/updateItem，参数：
// itemId // ID
// title // 标题
// avatar // 封面图片
// tagIdList // 标签列表
// text // 备注
// order // 排序
export function updateItem(data) {
    return request({
        url: '/gallery/updateItem',
        method: 'post',
        data,
    })
  }
// 删除物件 post gallery/removeItem，参数：
// itemId // ID
export function removeItem(data) {
    return request({
        url: '/gallery/removeItem',
        method: 'post',
        data,
    })
  }
// 获取单个物件 get gallery/findItem, 参数：
// itemId // ID
export function findItem(params) {
    return request({
        url: '/gallery/findItem',
        method: 'get',
        params,
    })
  }
// 获取物件列表 get gallery/findItemList, 参数：
// page
// size
// keyword // 关键词，搜索标题
export function findItemList(params) {
    return request({
        url: '/gallery/findItemList',
        method: 'get',
        params,
    })
  }
// 获取所有物件 get gallery/findItemAll, 参数：
// keyword // 关键词，搜索标题
export function findItemAll(params) {
    return request({
        url: '/gallery/findItemAll',
        method: 'get',
        params,
    })
  }
// ---------------------------------------------------------------------
// 媒体
// ----------------------------------------------------------------------

// 新增媒体 post gallery/createMedium，参数：
// imageUrl // 图片地址
// itemId // 物件ID
// text // 备注
// order // 排序
export function createMedium(data) {
    return request({
        url: '/gallery/createMedium',
        method: 'post',
        data,
    })
  }
// 修改媒体 post gallery/updateMedium，参数：
// mediumId // ID
// imageUrl // 图片地址
// itemId // 物件ID
// text // 备注
// order // 排序
export function updateMedium(data) {
    return request({
        url: '/gallery/updateMedium',
        method: 'post',
        data,
    })
  }
// 删除媒体 post gallery/removeMedium，参数：
// mediumId // ID
export function removeMedium(data) {
    return request({
        url: '/gallery/removeMedium',
        method: 'post',
        data,
    })
  }
// 获取单个媒体 get gallery/findMedium, 参数：
// mediumId // ID
export function findMedium(params) {
    return request({
        url: '/gallery/findMedium',
        method: 'get',
        params,
    })
  }
// 获取媒体列表 get gallery/findMediumList, 参数：
// page
// size
// itemTitle // 物件名称
export function findMediumList(params) {
    return request({
        url: '/gallery/findMediumList',
        method: 'get',
        params,
    })
  }
// 获取所有媒体 get gallery/findMediumAll, 参数：
// itemTitle // 物件名称
export function findMediumAll(params) {
    return request({
        url: '/gallery/findMediumAll',
        method: 'get',
        params,
    })
  }